import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "InfoFilled"
});
const _hoisted_1 = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-596.000000, -346.000000)" fill="currentColor"><g transform="translate(580.000000, 330.000000)"><g transform="translate(16.000000, 16.000000)"><path d="M8,1.5 C11.5898507,1.5 14.5,4.41014919 14.5,8 C14.5,11.5898507 11.5898507,14.5 8,14.5 C4.41014919,14.5 1.5,11.5898507 1.5,8 C1.5,4.41014919 4.41014919,1.5 8,1.5 Z M8.08808365,9.675537 C7.82117063,9.675537 7.59262634,9.73908147 7.4024508,9.8661704 C7.21227527,9.99325936 7.1171875,10.2164797 7.1171875,10.5358313 C7.1171875,10.8421483 7.21227527,11.0621099 7.4024508,11.1957163 C7.59262634,11.3293226 7.82117063,11.3961257 8.08808365,11.3961257 C8.34165112,11.3961257 8.56185429,11.3293226 8.74869343,11.1957163 C8.93553258,11.0621099 9.0289521,10.8421483 9.0289521,10.5358313 C9.0289521,10.2164797 8.93553258,9.99325936 8.74869343,9.8661704 C8.56185429,9.73908147 8.34165112,9.675537 8.08808365,9.675537 Z M9.0289521,4.5136719 L7.1171875,4.5136719 L7.34775208,8.9107304 L8.79838755,8.9107304 L9.0289521,4.5136719 Z"></path></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var infoFilled = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { infoFilled as default };
